import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@llt-frontend/react-material-progress';
import { Button } from '@llt-frontend/react-material-button';
import { AnalyticsEventTrigger } from '@llt-frontend/react-analytics-context';
import useUser from 'scripts/hooks/use-user';
import { FeatureList } from './feature-list';
import { PackageRepurchase } from './repurchase';
import { useGetRepurchaseOptions } from './repurchase/hooks';
import { PackageSelector } from './selector';

export const PackagePicker: React.FC = () => {
  const { t } = useTranslation('self-service/packages/repurchase');
  const [showSelector, setShowSelector] = React.useState(false);

  const { data: user, ...userRes } = useUser();
  const { mostRecentPackage, upsellPackage, ...packageRes } = useGetRepurchaseOptions(
    user?.client_id
  );

  if (userRes.isLoading || packageRes.isLoading) {
    return (
      <div className="package-tiles__progress">
        <span className="progress__spinner">
          <CircularProgress />
        </span>
      </div>
    );
  }

  return (
    <>
      {mostRecentPackage && (
        <>
          <PackageRepurchase mostRecentPackage={mostRecentPackage} upsellPackage={upsellPackage} />
          {!showSelector && (
            <AnalyticsEventTrigger
              analytics={{
                action: 'build-package',
                category: 'tutoring-packages',
                label: `build-package-button`,
              }}
              element={Button}
              elementProps={{
                contained: true,
                className: 'build-package-button',
                onClick: () => setShowSelector(true),
              }}
            >
              {t('buildButton')}
            </AnalyticsEventTrigger>
          )}
        </>
      )}
      {(!mostRecentPackage || showSelector) && <PackageSelector clientId={user?.client_id} />}
      <FeatureList />
    </>
  );
};
